import React from "react";
import PropTypes from "prop-types";

const RescheduleInfoBox = ({ text }) => {
  return typeof text === "string" && text.length > 0 ? <div className="info_box">{text}</div> : null;
};

RescheduleInfoBox.propTypes = {
  text: PropTypes.string,
};

RescheduleInfoBox.defaultProps = {
  text: "",
};

export default RescheduleInfoBox;
